import { create } from 'zustand';
import { GameMode } from '@/types/game.types';

interface GameState {
  mode: GameMode;
  activeLevel: string | null;
  activeChallenge: string | null;
  activeRoom: string | null;
  timerActive: boolean;
  timerValue: number;
  hintsUsed: number;

  // Actions
  setMode: (mode: GameMode) => void;
  setActiveLevel: (levelId: string | null) => void;
  setActiveChallenge: (challengeId: string | null) => void;
  setActiveRoom: (roomId: string | null) => void;
  startTimer: (duration: number) => void;
  pauseTimer: () => void;
  stopTimer: () => void;
  useHint: () => void;
  reset: () => void;
}

export const useGameStore = create<GameState>((set) => ({
  mode: null,
  activeLevel: null,
  activeChallenge: null,
  activeRoom: null,
  timerActive: false,
  timerValue: 0,
  hintsUsed: 0,

  setMode: (mode) => set({ mode }),
  setActiveLevel: (levelId) => set({ activeLevel: levelId }),
  setActiveChallenge: (challengeId) => set({ activeChallenge: challengeId }),
  setActiveRoom: (roomId) => set({ activeRoom: roomId }),

  startTimer: (duration) =>
    set({ timerActive: true, timerValue: duration }),

  pauseTimer: () => set({ timerActive: false }),

  stopTimer: () => set({ timerActive: false, timerValue: 0 }),

  useHint: () => set((state) => ({ hintsUsed: state.hintsUsed + 1 })),

  reset: () =>
    set({
      mode: null,
      activeLevel: null,
      activeChallenge: null,
      activeRoom: null,
      timerActive: false,
      timerValue: 0,
      hintsUsed: 0,
    }),
}));
